import { combineReducers } from 'redux'

import records from './records'
import uiFlags from './uiFlags'

export default combineReducers({ records, uiFlags })
